module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/005_About_the_author"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_FM1"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Acknowledgements"
    }
  }, [_vm._v("Picture Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Dedication"
    }
  }, [_vm._v("Acknowledgements and Dedications")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/009_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 1")]), _vm._v(" The Natural Death")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 2")]), _vm._v(" The Soldierly Death")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 3")]), _vm._v(" The Criminal Death")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 4")]), _vm._v(" The Deathbed")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 5")]), _vm._v(" Of Corpses, Coffins, and Carriages")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 6")]), _vm._v(" The Common and the Noble Funeral")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 7")]), _vm._v(" Royal Funerals")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 8")]), _vm._v(" The Unorthodox Burial")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Chapter 9")]), _vm._v(" Remembrance")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/019_BM1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_"
  }, [_vm._v("Conclusion:")]), _vm._v(" The Seventeenth Century and Beyond")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/020_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2_"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/021_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0